<template>
  <div class="sidebar">
    <div class="logo-container">
      <h1 v-if="sidebar.opened" class="logo-title">达达电竞</h1>
      <span v-else class="logo-mini">达</span>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="!sidebar.opened"
        :background-color="variables.sidebarBg"
        :text-color="variables.sidebarText"
        :active-text-color="variables.sidebarActive"
        :unique-opened="true"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem.vue'

export default {
  name: 'Sidebar',
  components: { SidebarItem },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    routes() {
      return this.$store.getters.permissionRoutes.filter(r => !r.hidden)
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) return meta.activeMenu
      return path
    },
    variables() {
      return {
        sidebarBg: '#001529',
        sidebarText: 'rgba(255,255,255,0.65)',
        sidebarActive: '#165DFF'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  height: 100%;
  background: #001529;
}

.logo-container {
  height: $navbar-height;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #002140;

  .logo-title {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .logo-mini {
    color: #165DFF;
    font-size: 20px;
    font-weight: 700;
  }
}

::v-deep .el-menu {
  border-right: none;
}

::v-deep .el-menu-item.is-active {
  background-color: #165DFF !important;
}

::v-deep .el-submenu__title:hover,
::v-deep .el-menu-item:hover {
  background-color: rgba(22, 93, 255, 0.2) !important;
}
</style>
